import React, { useState, useEffect } from 'react'
import Grid from '@mui/joy/Grid'
import './Stamp.css'
import EmptyStamp from './EmptyStamp'
import ImageStamp from './ImageStamp'

type StampProps = {
  gridKey: number
  collected: boolean
  index: number
  font: string
  stampImagePath: string
  isLoading: boolean
  textColor: string
  date: string
}

const Stamp = (props: StampProps) => {
  const [stamped, setStamped] = useState(false)

  useEffect(() => {
    handleStamp()
  }, [props.collected])

  const handleStamp = () => {
    setStamped(true)
    setTimeout(() => {
      setStamped(false)
    }, 1000)
  }

  return (
    <Grid
      container
      xs={4}
      key={props.gridKey}
      sx={{ justifyContent: 'center', alignItems: 'center', height: 95 }}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
      >
        {props.collected ? (
          <ImageStamp
            collected={props.collected}
            font={props.font}
            stampImagePath={props.stampImagePath}
            textColor={props.textColor}
            date={props.date}
            stamped={stamped}
          />
        ) : (
          <EmptyStamp textColor={props.textColor} />
        )}
      </Grid>
    </Grid>
  )
}

export default Stamp
